import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import NewToggleButton from '../../common/NewToggleButton';

const NewSearchOnlyResidences = ({ name, id, storedValue }) => {
  const { t } = useTranslation();

  return (
    <div className="filters__section">
      <NewToggleButton
        name={name}
        id={id}
        labelText={t('search.form.only_residences')}
        storedValue={storedValue}
      />
    </div>
  );
};

NewSearchOnlyResidences.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  storedValue: PropTypes.bool
};

export default NewSearchOnlyResidences;
